{
  "view": {
    "title": "Parking spots",
    "parkingSpot": "Parking spot",
    "reserve": "Reserve",
    "details": "Details",
    "parkingArea": "Parking area",
    "description": "Here you can view parking spots and reserve your own parking spot by clicking on the desired spot.",
    "queueDescription": "Reserved spots can be queued.",
    "reservationsNotSet": "Parking spot reservations are not set up for this property.",
    "complimentaryInfo": "You have {{count}} complimentary parking spot(s) available.",
    "disabledReservationInfo": "Disabled parking spots must be reserved via customer service.",
    "limitReached": "You have reached the maximum number ({{max}}) of parking spots.",
    "noParkingAreas": "No parking areas available"
  },
  "legend": {
    "available": "Available",
    "reservedOrInactive": "Reserved",
    "mine": "My spot",
    "mineUpcoming": "My spot starting soon",
    "notInUse": "Not in use",
    "ending": "Ending soon",
    "starting": "Starting soon",
    "title": "Icon explanations"
  },
  "aria": {
    "availableIndicator": "Color indicator for an available spot",
    "reservedIndicator": "Color indicator for a reserved spot",
    "mineIndicator": "Color indicator for your own spot",
    "mineUpcomingIndicator": "Color indicator for a spot starting soon",
    "notInUseIndicator": "Color indicator for a spot that is not in use"
  },
  "price": {
    "label": "Price",
    "free": "Free",
    "perMonth": "{{amount}} / month",
    "fromPerMonth": "from {{amount}} / month",
    "total": "Total"
  },
  "equipment": {
    "covered": "Covered",
    "ev_charger": "EV charging",
    "garage": "Garage",
    "heating_outlet": "Heated outlet",
    "motorbike_spot": "Motorbike spot",
    "yard": "Yard",
    "building": "Hall",
    "disabled_spot": "Accessible spot",
    "covered_motorbike_spot": "Covered motorbike spot",
    "covered_disabled_spot": "Covered accessible spot",
    "garage_motorbike_spot": "Garage motorbike spot",
    "garage_disabled_spot": "Garage accessible spot",
    "building_motorbike_spot": "Hall motorbike spot",
    "building_disabled_spot": "Hall accessible spot"
  },
  "tooltip": {
    "reservation": {
      "current": { "label": "Reservation" },
      "future": { "label": "Upcoming reservation" },
      "previous": { "label": "Previous reservation" }
    },
    "available": "Available",
    "openEnded": "(until further notice)"
  },
  "spot": {
    "label": "Spot",
    "status": "Status",
    "equipment": "Spot features",
    "details": "Details"
  },
  "success": {
    "title": "Parking spot reserved successfully!",
    "starts": "Reservation starts"
  },
  "address": {
    "at": "at the address"
  },
  "effectiveFrom": "Effective from",
  "acceptRules": "I accept the rules of {{address}} and the parking spot reservation terms",
  "date": {
    "placeholder": "dd.mm.yyyy"
  },
  "error": {
    "contractMissing": "Contract information is missing — cannot make a reservation.",
    "reservationFailed": "Reservation failed. Please try again in a moment.",
    "overlap": "The selected parking spot cannot be reserved. Choose another spot or try again later.",
    "terminationFailed": "Termination failed. Please try again in a moment."
  },
  "terminate": {
    "endDateLabel": "Effective end date",
    "endDateTooEarly": "The end date must be at least {{date}}",
    "cta": "End reservation",
    "success": "Reservation ended",
    "terminateTitle": "Parking spot reservation ending",
    "terminateFrom": "The reservation for parking spot {{spot}} ends on {{date}}"
  },
  "cancel": {
    "futureReservationLabel": "Reservation takes effect",
    "reservationStartedOn": "Reservation start date {{date}}",
    "cta": "Cancel reservation",
    "success": "Reservation cancelled",
    "error": {
      "failed": "Cancellation failed. Please try again in a moment."
    }
  },
  "queue": {
    "join": "Join the queue",
    "leave": "Leave the queue",
    "empty": "You are not in the parking spot queue.",
    "youAreWaiting": "You are waiting for a parking spot with: {{features}}",
    "additionalInfoSuffix": ". {{info}}",
    "loading": "Loading…",
    "loadError": "Failed to load the parking queue."
  },
  "form": {
    "fields": {
      "equipment": {
        "label": "Requested spot types",
        "helper": "Select one or more types (e.g. yard, shelter, EV charging)."
      },
      "additionalInfo": {
        "label": "Additional information",
        "placeholder": "e.g. need for charging or time constraint."
      }
    },
    "actions": {
      "cancel": "Cancel",
      "join": "Join the queue"
    },
    "parkingSpotContractDocumentLink": "Rules",
    "parkingSpotTermsOfUseLink": "Reservation terms"
  },
  "errors": {
    "equipmentRequired": "Select at least one spot type",
    "equipmentUnavailable": "You cannot queue for the selected spot type because a matching spot is available.",
    "joinFailed": "Failed to join the queue"
  }
}
